module.exports = __webpack_public_path__ + "static/media/Brand.a3c8bfb9.svg";